import { action } from 'easy-peasy'

export const appModel = {
	// States
	sidebar: false,
	app_type: null,
	language: localStorage.getItem('sdoc_lang') || 'th',
	// Function
	setSideBar: action((state, isClose) => {
		state.sidebar = isClose
	}),
	setAppType: action((state, appType) => {
		state.app_type = appType
	}),
	setLanguage: action((state, lang) => {
		state.language = lang
		localStorage.setItem('sdoc_lang', lang)
	}),
}
